const numberReg = /^\d+$/
const phoneReg = /^1[3-9][0-9]{9}$/
const emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
import i18n from '@/locales/index'
const { t } = i18n.global
export function checkPhoneOrEmailForm(rule, value, callback){
	if(!phoneReg.test(value) && !emailReg.test(value)){
		callback(new Error())
	}else{
		callback()
	}
}
export function checkPhoneForm(rule, value, callback){
	if(!phoneReg.test(value)){
		callback(new Error())
	}else{
		callback()
	}
}
export function checkNumberForm(rule, value, callback){
	if(!numberReg.test(value)){
		callback(new Error())
	}else{
		callback()
	}
}
export function checkEmailForm(rule, value, callback){
	if(!emailReg.test(value)){
		callback(new Error())
	}else{
		callback()
	}
}

export function checkPhoneOrCodeForm(rule, value, callback){
	if( value.length == 11){
		if(!phoneReg.test(value)){
			callback(new Error())
		}else{
			callback()
		}
	}else{
		callback()
	}
}


export function validatePasswordOld (rule, value, callback) {
	if (value === '') {
		callback(new Error('用户密码不能为空'));
	} else {
	// 检查密码强度
	if (value.length < 8) {
		callback(new Error(t('system.user.passwordMinLength')));
	} else if (!/(?=.*[a-z])/.test(value)) {
		callback(new Error(t('system.user.passwordLowercase')));
	} else if (!/(?=.*[A-Z])/.test(value)) {
		callback(new Error(t('system.user.passwordUppercase')));
	} else if (!/(?=.*\d)/.test(value)) {
		callback(new Error(t('system.user.passwordNumber')));
	} else if (!/(?=.*[!@#$%^&*])/.test(value)) {
		callback(new Error(`${t('system.user.passwordSpecialChar')}(!@#$%^&*)`));
	} else {
		callback();
	}
	}
}

export function validatePassword(rule, value, callback) {
  if (value === '') {
    callback(new Error('用户密码不能为空'));
  } else if (value.length < 8 || !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])/.test(value)) {
    callback(new Error(`${t('system.user.passwordRequirementNew')}(!@#$%^&*)`));
  } else {
    callback();
  }
}

export function validatePassword1(value) {
  if (value === '' || value === undefined) {
    return '用户密码不能为空';
  }
  if (value.length < 8) {
    return t('system.user.passwordMinLength');
  } else if (!/(?=.*[a-z])/.test(value)) {
    return t('system.user.passwordLowercase');
  } else if (!/(?=.*[A-Z])/.test(value)) {
    return t('system.user.passwordUppercase');
  } else if (!/(?=.*\d)/.test(value)) {
    return t('system.user.passwordNumber');
  } else if (!/(?=.*[!@#$%^&*])/.test(value)) {
    return `${t('system.user.passwordSpecialChar')}(!@#$%^&*)`;
  }
  return ''; // 空字符串表示校验通过
}

export function validateConfirmPass (passwordForm) {
	return (rule, value, callback) => {
		if (value !== passwordForm.password) {
			callback(new Error(t('system.user.passwordMismatch')));
		} else {
			callback();
		}
	}
}
        
